import { percentToHex } from "_common/utils";
import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {
	const btnState = props?.disabled ? "disabled" : props?.active ? "clicked" : "default";

	const button = theme.other.colors.textBtn;

	const tansparentHexCode = percentToHex ( theme.other.darkMode ? 40 : 10 );

	const hoverBackgroundColor =  props?.color ? props?.color + tansparentHexCode : button[btnState].text + tansparentHexCode;

	const padding      = props?.size === "small" ? "0.5rem 1rem" : "1rem 3rem";
	const borderRadius = props?.size === "small" ? "0.8rem" : "1rem";

	const fontSize = props?.size === "small" ? "1.3rem" : "1.5rem";

	return { textButton: {
		color         : button.default.text,
		background    : "transparent",
		padding       : padding,
		textTransform : "none",
		width         : props?.fullWidth ? "100%" : "initial",
		boxSizing     : "content-box",
		borderRadius  : borderRadius,

		"&:hover": {
			background: hoverBackgroundColor
		}

	},
	buttonText: {
		color      : props?.color ? props?.color : button[btnState].text,
		fontWeight : theme.other.typographyNew.fontWeightMapping[props?.fontWeight],
		fontSize   : fontSize

	} };
} );